var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-operate"},[_c('div',{staticClass:"home-operate__edit",on:{"click":_vm.edit}},[_vm._v("编辑")]),_c('div',{staticClass:"home-operate__delete",on:{"click":_vm.del}},[_vm._v("删除")])])
}
var staticRenderFns = []

export { render, staticRenderFns }